<div style="margin-top: 15px; width: 99%;">
    <button type="button" class="host-cta" (click)="onAddPaymentAction()">Add New Bank Account Details</button>
    <div *ngIf="accountDetaiils.length === 0" style="margin: 10px; padding: 5px; color: rgb(214, 55, 55); border: 1px solid pink; border-radius: 5px;">
      No Account Details Found.
    </div>
    <div class="grid-container">
      <div class="grid-item" *ngFor="let account of accountDetaiils; let index = index;">
    <div class="matCard mat-elevation-z4" >
        <mat-icon class="editBtn" (click)="onUpdateAccountDetails(account)" matTooltip="Update Account Details"
        *ngIf="account.isUpdateAllowed === true">edit</mat-icon>
        <mat-icon class="deleteBtn" (click)="onDeleteAccount(account)" matTooltip="Delete Account Detail"
        *ngIf="account.isUpdateAllowed === true">delete</mat-icon>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6">
                Account Number : <span class="contentCls"> {{convertAccountNumber(account.accountNumber)}}</span>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6">
                Name On Account : <span class="contentCls"> {{account.nameOnAccount}}</span>
              </div>              
            </div>               
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6">
                Routing Number : <span class="contentCls"> *********** </span>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6">
                Street Address : <span class="contentCls"> {{account.streetAddress}}</span>
              </div>  
               
            </div> 
              <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6">
                City : <span class="contentCls"> {{account.city}}</span>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6">
                State : <span class="contentCls"> {{account.state}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6">
                ZipCode : <span class="contentCls"> {{account.zipCode}}</span>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6">
                IsUpdateAllowed : <span class="contentCls"> {{account.isUpdateAllowed}}</span>
              </div>
               
            </div>
            <div class="row">
              <div class="col-12">
                IsActive : <span class="contentCls"> 
                <mat-slide-toggle labelPosition="after" [(ngModel)]="account.isActive" (change)="onChangeActiveStatus(account)" [disabled]="account.isActive"></mat-slide-toggle>
                <span *ngIf="account.isActive ===  true">Yes</span>
                <span *ngIf="account.isActive ===  false">No</span>
                </span>
              </div>
               
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>